import MailIcon from "@mui/icons-material/MailOutlineRounded";
import { Box, Divider, Stack, Typography } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import FileIcon from "@entrilia/shared/components/FileIcon";

interface Props {
  title: string;
  fileExtension?: string;
  isEmail?: boolean;
  onClose: () => void;
}

const WorkflowFilePreviewHeader = ({ title, fileExtension, isEmail, onClose }: Props) => {
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2, py: 1 }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          {isEmail ? <MailIcon color="secondary" /> : <FileIcon fileExtension={fileExtension ?? ""} />}
          <Typography variant="subtitle1" component="span">
            {title}
          </Typography>
        </Stack>
        <CloseIconButton color="secondary" onClick={onClose} />
      </Box>
      <Divider />
    </>
  );
};

export default WorkflowFilePreviewHeader;
